<template>
  <v-layout 
    row>
    <v-flex 
      xs12 
      md6 
      offset-md3>
      <v-hover v-if="orderedNotifications.length === 0">
        <v-card
          slot-scope="{ hover }"
          class="mt-5 py-5 roundedcard"
          :class="`elevation-${hover ? 20 : 12}`"
          style="width: 300px; margin: auto;">
          <v-card-text class="my-5">
            <v-layout 
              row 
              wrap>
              <v-flex
                xs12>
                <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

                <v-flex class="mt-2 text-xs-center">
                  <v-icon
                    color="secondary"
                    size="100">
                    far fa-quote-right
                  </v-icon>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-hover>
      <v-card 
        v-else
        max-width="600" 
        style="margin: auto">
        <v-layout 
          row 
          wrap>
          <v-flex 
            xs12> 
            <v-list
          
              three-line>
              <template 
                v-for="(notification, index) in orderedNotifications">
                <app-friend-request 
                  v-if="notification.subject === 'friendrequest'"
                  :key="index" 
                  :notification="notification"></app-friend-request>
                <app-event-advice 
                  v-if="notification.subject === 'event-advice'"
                  :key="index" 
                  :notification="notification"></app-event-advice>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapState, mapGetters } from 'vuex'

import NotificationFriendRequest from '@/components/View_Notifications/Notification_friend_request.vue'
import NotificationEventAdvice   from '@/components/View_Notifications/Notification_event_advice.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-friend-request": NotificationFriendRequest,
    // eslint-disable-next-line
    "app-event-advice": NotificationEventAdvice,
  },
  data() {
   
    return {
      fab: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      notifications: state => state.user.notifications
    }),
    ...mapGetters({
      orderedNotifications: 'orderedNotifications'
    })
  },
  methods: {
    
  }
}
</script>
